<template>
    <el-form :inline="true" :model="queryParam" class="mainSearch">
      <el-form-item label="标题">
        <el-input v-model="queryParam.title" placeholder="建议标题" />
      </el-form-item>
      <el-form-item label="类型">
          <el-select
            style="width:100%"
            v-model="queryParam.typename"
            clearable
            placeholder="请选择类型"
          >
            <el-option
              v-for="item in adviceTypeData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="queryParam.status" placeholder="建议状态" style="width:120px">
          <el-option label="未处理" :value="1" />
          <el-option label="已处理" :value="2" />
          <el-option label="未采用" :value="3" />
          <el-option label="已采用" :value="4" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getListAdvice">查询</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-form-item>
    </el-form>
    <el-row>
      <el-col :span="24">
        <div class="mainTableTop">
          <el-button
            type="primary"
            @click="(dialog = true), doAdviceAdd()"
            v-hasPermission="['advice:add']"
            >添加建议</el-button>
        </div>
      </el-col>
    </el-row>
  
    <el-row class="mainTableBox">
      <el-col :span="24" class="mpadding">
        <el-table ref="tableRef" v-loading="loadingData" :data="tableData" class="mainTable">
          <el-table-column prop="title" label="标题"/>
          <el-table-column prop="typename" label="类型"/>
          <el-table-column prop="created" label="创建时间">
            <template #default="scope">
              <span
                v-text="
                  util.formatDateUnix(scope.row.created, 'yyyy-MM-dd hh:mm')
                "
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" >
        <template #default="scope">
          <el-tag
            round
            :type="scope.row.status === 1 ? 'success' : 'danger'"
            disable-transitions
            ><span v-text="util.showAdviceStatus(scope.row.status)"></span>
          </el-tag>
        </template>
      </el-table-column>
          <el-table-column label="操作" fixed="right" width="160">
            <template #default="scope">
              <el-link
              type="primary"
              @click="(dialog = true), doAdviceEdit(scope.$index, scope.row)"
              v-hasPermission="['advice:edit']"
              >编辑</el-link>
  
              <el-popconfirm
                confirm-button-type="primary"
                confirm-button-text="确定"
                cancel-button-text="取消"
                icon-color="#626AEF"
                title="您确定删除吗？"
                width="200px"
                @confirm="doAdviceDelete(scope.$index, scope.row)"
              >
                <template #reference>
                  <el-link
                    type="danger"
                    v-hasPermission="['advice:delete']"
                    >删除</el-link
                  >
                </template>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  
    <el-row class="mainTableBottom">
      <el-col :span="8">
        <!-- <div>
          <el-button type="primary">添加建议</el-button>
        </div> -->
      </el-col>
      <el-col :span="16">
        <div style="float: right">
          <el-pagination
            :hide-on-single-page="false"
            v-model:page-size="queryParam.pageSize"
            :page-sizes="[10, 15, 20, 30]"
            :background="true"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="changeChangeSize"
            @current-change="changePage"
          />
        </div>
      </el-col>
    </el-row>
  
    <el-drawer
      ref="drawerRef"
      v-model="dialog"
      :title="title"
      direction="rtl"
      :close-on-click-modal="false"
      size="60%"
      @close="doAdviceClose()"
    >
      <div class="common-drawer__content">
        <el-form
          ref="adviceFormRef"
          :model="adviceForm"
          :rules="rules"
          label-width="120px"
        >
        <el-form-item label="类型" prop="typename">
          <el-select
            style="width:100%"
            v-model="adviceForm.typename"
            clearable
            placeholder="请选择类型"
          >
            <el-option
              v-for="item in adviceTypeData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
            <el-input
              v-model.trim="adviceForm.title"
              placeholder="请输入标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="建议描述" prop="content">
            <editor ref="editorRef" :content="adviceForm.content" @update:content="updateContent"></editor>
          </el-form-item>
          <el-form-item label="建议附件" prop="attachment">
            <el-upload
              class="upload-demo"
              action="/api/upload/common"
              :auto-upload="true"
              :headers="headerUpload"
              :on-success="doUploadSuccess2"
              :before-upload="beforeUpload2"
              multiple
              v-model="fileList"
              ref="fileUpload2"
              accept="image/png, image/jpeg, image/jpg,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/zip,application/pdf"
              name="picture"
            >
            <template #trigger>
              <el-button type="primary">选择附件（可多选）</el-button>
            </template>
             
              <template #tip>
                <div class="el-upload__tip">
                  请上传Png、Jpeg、Jpg、Word、Pdf、Zip后缀名且小于10M的文件。
                 <template  v-for="(item,index) in fileList" :key="index">
                  <div style="cursor: pointer;">
                    <el-link type="primary" @click="doDownload(item.name,item.url)">{{item.name}}</el-link> 
                    <el-icon :size="14" style="vertical-align: -2px; margin-left: 15px;" @click="deleteFileList(index)">
                      <Delete />
                    </el-icon>
                  </div>
                  
                </template>
                </div>
              </template>
            </el-upload>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-radio-group v-model="adviceForm.status">
              <el-radio :label="1">未处理</el-radio>
              <el-radio :label="2">已处理</el-radio>
              <el-radio :label="3">未采用</el-radio>
              <el-radio :label="4">已采用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div class="common-drawer__footer">
          <el-button @click="doAdviceClose()">关闭</el-button>
          <el-button type="primary" :loading="loading" @click="doAdviceSave">{{
            loading ? "提交中 ..." : "提交"
          }}</el-button>
        </div>
      </div>
    </el-drawer>
  </template>
  
  <script setup>
  import { ref, onMounted ,defineEmits } from "vue";
  // import { useRouter } from "vue-router";
  import { ElDrawer, ElTable, ElMessage } from "element-plus";
  import { listAdvice, deleteAdvice,saveAdvice  } from "@/api/advice";//
  import { downloadFile } from "@/api/common";
  
  import editor from '@/components/common/editor.vue'
  
  import util from "@/util/tool.js";
  // import storage from "@/util/storage.js";
  
  import store from "@/store";

  import config from "@/util/config.js";

  
  let timer;
  
  const dialog = ref(false);
  const loading = ref(false);
  const loadingData = ref(true);
  
  const fileList = ref([])
  const emit = defineEmits(["click"]); // 声明父触发事件
  
  const adviceTypeData = config.configAdviceTypeData;

  
  // const router = useRouter();
  // let open = (routeName, row) => {
  //   storage.saveSessionObject("advicePath",queryParam.value)
  //   router.push({
  //     name: routeName,
  //     params: { id: row.adviceid },
  //     query: { eflag:row.eflag, name: row.name },
  //   });
  // };
  
  const drawerRef = ref(ElDrawer);
  const editorRef = ref()
  
  const tableData = ref();
  const total = ref(0);
  const pageSize = ref(15); //每页显示条数
  
  let adviceFormRef = ref();
  let title = ref("添加建议");
  
  // const defaultSelectDepart = ref([])
  
  //onMounted方法
  onMounted(() => {
    getListAdvice();
  });
  
  
  //搜索查询
  const queryParam = ref({
    pageNo: 1,
    pageSize: pageSize.value,
    typename:"",
    status: "",
    title: "",
  });
  const resetSearch = () => {
    queryParam.value = {
      pageNo: 1,
      pageSize: pageSize.value,
      typename: "",
      status: "",
      title: "",
    };
    getListAdvice();
  };
  
  //建议表单项
  let adviceForm = ref({
    adviceid: null,
    typename: "",
    title: "",
    attachment:"",
    content: "",
    status:1,
  });
  
  //添加建议
  const doAdviceAdd = () => {
    title.value = "添加建议";
    // console.log('add',adviceForm.value)
  
    // adviceForm.value.content = ''
    // editorRef.value.valueHtml = '<p></p>'
    resetForm();
  };
  
  //编辑建议
  const doAdviceEdit = (index, obj) => {
    title.value = "编辑建议";

    fileList.value = []
  
    adviceForm.value = {
      adviceid: obj.adviceid,
        typename: obj.typename,
        title: obj.title,
        attachment: obj.attachment,
        content: obj.content,
        status: obj.status,
    };
    setTimeout(function(){
    //   startedEnded.value = [util.getFormateDate(obj.started), util.getFormateDate(obj.ended)]
      adviceForm.value.typename = obj.typename
      if (obj.attachment) {
        fileList.value = JSON.parse(obj.attachment)
      }
    },400)
  
    // editorRef.value && (editorRef.value.valueHtml && (editorRef.value.valueHtml = adviceForm.value.content));
    editorRef.value.valueHtml = adviceForm.value.content
  
  };
  const resetForm = () => {
    adviceForm.value = {
      adviceid: null,
      typename: "",
      title: "",
      attachment:"",
      content: "",
      status:1,
    };
    fileList.value = []
    // editorRef.value.valueHtml = ''
    editorRef.value && (editorRef.value.valueHtml && (editorRef.value.valueHtml = ''));
  };
  
  
  const updateContent = (e) => {
    adviceForm.value.content = e
  }
  
  //关闭建议表单弹窗
  const doAdviceClose = () => {
    loading.value = false;
    dialog.value = false;
    clearTimeout(timer);
    adviceFormRef.value.resetFields()
  };
  
  //保存建议数据
  const doAdviceSave = () => {
    adviceFormRef.value.validate((valid) => {
      if (!valid) {
        //ElMessage("请先完善表单数据填写！");
        return;
      }
      saveAdvice(adviceForm.value).then((res) => {
        loading.value = true;
        timer = setTimeout(() => {
          // 动画关闭需要一定的时间
          setTimeout(() => {
            loading.value = false;
          }, 400);
          if (res.data.code === 1) {
            getListAdvice();
            doAdviceClose();
          } else {
            ElMessage.error(res.data.msg);
          }
        }, 1000);
      });
    });
  };
  
  //更新建议状态
  const doAdviceDelete = (index, obj) => {
    // console.log('obj.adviceid',obj.adviceid.toString())
    deleteAdvice(obj).then((res) => {
      // console.log(res);
      if (res.data.code === 1) {
        getListAdvice();
      } else {
        ElMessage.error(res.data.msg);
      }
    });
  };
  
  //分页
  const changePage = (current) => {
    queryParam.value.pageNo = current;
    getListAdvice();
  };
  const changeChangeSize = (size) => {
    pageSize.value = size;
    queryParam.value.pageSize = size;
    getListAdvice();
  };
  
  //建议列表API
  const getListAdvice = () => {
    listAdvice(queryParam.value).then((res) => {
      tableData.value = res.data.extend.pages.list;
      total.value = res.data.extend.pages.total;
      queryParam.value.pageSize = pageSize.value;
      loadingData.value = false
    });
  };
  
  //建议表单验证规则
  const rules = ref({
    typename: [
      {
        required: true,
        message: "请选择建议类型",
        trigger: "blur",
      },
    ],
    title: [
      {
        required: true,
        message: "请输入标题",
        trigger: "blur",
      },
      {
        min: 2,
        max: 200,
        message: "标题长度2到200",
        trigger: "blur",
      },
    ],
    // content: [
    //   {
    //     required: true,
    //     message: "请输入建议描述",
    //     trigger: "blur",
    //   },
    // ],
    
  });
  
  
  const resultMsg = ref();
  
  
  const filefail2 = ref("");
  const resultMsg2 = ref();
  const fileUpload2 = ref();
  const doUploadSuccess2 = (response) => {  
    if (response.code === 0) {    
      ElMessage.error(response.msg)
    } else {
      resultMsg2.value = response.msg
      filefail2.value = response.url
      let obj = {name:response.name,size:response.size,url:response.url,type:response.type}
      fileList.value.push(obj)
      adviceForm.value.attachment = JSON.stringify(fileList.value)
      setTimeout(function(){
        fileUpload2.value.clearFiles()
      },1000)
    }
  };
  const beforeUpload2 = (rawFile) => {
    if (rawFile.type !== 'application/msword' && rawFile.type !=='application/vnd.openxmlformats-officedocument.wordprocessingml.document' && rawFile.type !=='application/zip' && rawFile.type !=='application/pdf' && rawFile.type !== 'image/png' && rawFile.type !=='image/jpeg' && rawFile.type !=='image/jpg') {
      ElMessage.error('请上传Png、Jpeg、Jpg、Word、Pdf、Zip格式文件!')
      return false
    } else if (rawFile.size / 1024 / 1024 > 10) {
      ElMessage.error('请上传小于10MB的文件!')
      return false
    }
    resultMsg.value = '正在上传处理中，请勿关闭或跳转页面！'
    return true
  }
  //删除附件
  const deleteFileList = (index) => {
    fileList.value.splice(index,1)
    adviceForm.value.attachment = JSON.stringify(fileList.value)
  }
  
  const headerUpload = ref({
    Authorization: store.state.user.token,
  });
  
  const doDownload = (filename, url) => {
    let data = {filename,url}
    downloadFile(data).then((response) => {
      const content = response.data;
      const blob = new Blob([content], {
        type: "application/octet-stream"
      });
      const downloadElement = document.createElement("a");
      const href = window.URL.createObjectURL(blob);
      downloadElement.href = href;
      downloadElement.download = decodeURI(response.headers["filename"]);
      document.body.appendChild(downloadElement);
      downloadElement.click();
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
      emit("click");
    });
  }
  
  </script>
  <style scoped>
  .checkAll {
    padding-left: 20px;
      border-bottom: 1px solid #f4f4f4;
      display: flex;
  }
  </style>
  